import { gql } from "@/gql/__generated__";
import { Get_Active_OrganizationQuery } from "@/gql/__generated__/graphql";
import { useQuery } from "@apollo/client";
import { useParams } from "@tanstack/react-router";
import { useLocalStorage } from "usehooks-ts";

export type ActiveOrganization = Extract<
  Get_Active_OrganizationQuery["organization"],
  { __typename?: "Organization" }
>;
export const GET_ACTIVE_ORGANIZATION = gql(`
  query GET_ACTIVE_ORGANIZATION ($organizationSlug: String!) {
    organization(organizationSlug: $organizationSlug) {
      ... on Organization {
        id
        name
        slug
      }
    ... on OrganizationNotFound {
      id
      slug
    }
    }
  }
`);

export const useUserActiveOrganization = () => {
  const [latestOrganizationSlug] = useLocalStorage<string | null>(
    "latestOrganizationSlug",
    null
  );
  const { organizationSlug } = useParams({ strict: false });
  const { data, loading, ...rest } = useQuery(GET_ACTIVE_ORGANIZATION, {
    variables: {
      organizationSlug: organizationSlug || latestOrganizationSlug || ""
    },
    skip: !organizationSlug && !latestOrganizationSlug
  });

  const activeOrganization: ActiveOrganization | undefined =
    (data?.organization.__typename === "Organization" && data.organization) ||
    undefined;

  return { activeOrganization, loading, ...rest };
};
